// Pure, dependency-free humanisation of Axios errors into controlled customer copy.
// Maps backend-structured detail, controlled strings, and raw Axios/network/timeout/5xx —
// raw Axios/browser implementation strings never reach the UI. Unit-tested in humanizeError.test.js.
export function humanizeAxiosError(err) {
  const detail = err?.response?.data?.detail;
  const code = (detail && typeof detail === "object") ? detail.code : undefined;
  if (code === "TERMINAL_ACCESS_EXPIRED") {
    return "This shipment is closed and is no longer available in your active work. See Handled History.";
  }
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  if (err?.code === "ECONNABORTED" || /timeout/i.test(err?.message || "")) {
    return "This is taking longer than expected. Please try again.";
  }
  if (!err?.response) return "We can't reach Air12 right now. Check your connection and try again.";
  if (err.response.status >= 500) return "Something went wrong on our side. Please try again in a moment.";
  return "Something went wrong. Please try again.";
}
